import "./Services.css";
import { FaChartBar } from "react-icons/fa";

export default function Services() {
  return (
    <section className="services-section" id="services">

      <div className="services-container">

        {/* LEFT RED BOX */}
        <div className="services-left">
          <h2>
            Why Choose Gold Company to Sell Gold Jewels?
          </h2>

          <p>
            We provide the right value for your gold with complete transparency.
            Our experts check purity and weight using latest technology.
            No hidden charges. Get best market price instantly.
          </p>

          <button className="know-btn">To Know More</button>
        </div>

        {/* RIGHT GRID */}
        <div className="services-right">

          {/* CARD */}
          <div className="service-card">
            <div className="icon"><FaChartBar /></div>
            <h3>SELL GOLD</h3>
            <p>Sell your old gold and get live market price instantly.</p>
          </div>

          <div className="service-card">
            <div className="icon"><FaChartBar /></div>
            <h3>ON SPOT PAYMENT</h3>
            <p>Immediate hassle-free payment service on your gold.</p>
          </div>

          <div className="service-card">
            <div className="icon"><FaChartBar /></div>
            <h3>LATEST TOOLS</h3>
            <p>Advanced German technology for accurate gold evaluation.</p>
          </div>

          <div className="service-card">
            <div className="icon"><FaChartBar /></div>
            <h3>RELEASE GOLD</h3>
            <p>We help release pledged gold quickly and safely.</p>
          </div>

          <div className="service-card">
            <div className="icon"><FaChartBar /></div>
            <h3>RENTING GOLD</h3>
            <p>Flexible gold renting options for your needs.</p>
          </div>

          <div className="service-card">
            <div className="icon"><FaChartBar /></div>
            <h3>EMI OPTION</h3>
            <p>Easy EMI options available for your convenience.</p>
          </div>

        </div>

      </div>

    </section>
  );
}